import { useTranslation } from 'react-i18next'
import { useDeleteTenantMutation, useToggleTenantStatusMutation } from '@/entities/tenant'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface TenantStatusToggleProps {
  tenantId: string
  isActive: boolean
}

export function TenantStatusToggle({ tenantId, isActive }: TenantStatusToggleProps) {
  const { t } = useTranslation()
  const toggleMutation = useToggleTenantStatusMutation()
  const deleteMutation = useDeleteTenantMutation()
  const isPending = toggleMutation.isPending || deleteMutation.isPending

  async function handleConfirmed() {
    try {
      if (isActive) {
        await deleteMutation.mutateAsync(tenantId)
      } else {
        await toggleMutation.mutateAsync(tenantId)
      }
      showToast.success(t('tenant.statusUpdateSuccess'))
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={isPending}
        confirmEnableTitle={t('tenant.enableConfirm')}
        confirmDisableTitle={t('tenant.disableConfirm')}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
